import { DateTime } from "luxon"

export function calculateAgeFromBirthDay(birthday: string, relativeTo?: DateTime): number {
    // calculate age from birthday using luxon
    const birthDay = DateTime.fromISO(birthday)
    const now = relativeTo ?? DateTime.now()
    return Math.floor(now.diff(birthDay, "years").years)
}
